import { format, subDays, addDays } from 'date-fns';

export const contacts = [
  {
    id: '1',
    name: 'Juan Pérez',
    position: 'Director Comercial',
    email: 'juan.perez@techcorp.com',
    phone: '+54 11 1234-5678',
    status: 'Cliente',
    lastContact: subDays(new Date(), 2),
    notes: 'Interesado en soluciones de automatización'
  },
  {
    id: '2',
    name: 'María González',
    position: 'Gerente de Compras', 
    email: 'maria.gonzalez@retailplus.com',
    phone: '+54 351 9876-5432',
    status: 'Lead',
    lastContact: subDays(new Date(), 5),
    notes: 'Buscando proveedores para nueva línea de productos'
  },
  {
    id: '3',
    name: 'Carlos López',
    position: 'Gerente General',
    email: 'carlos.lopez@global.com',
    phone: '+54 341 4567-8901',
    status: 'Cliente',
    lastContact: subDays(new Date(), 1),
    notes: 'Renovación de contrato anual pendiente con Global. Contacto para nuevo proyecto con TechCorp.'
  },
  {
    id: '4',
    name: 'Ana Rodríguez',
    position: 'Directora de Operaciones',
    email: 'ana.rodriguez@techcorp.com',
    phone: '+54 11 2345-6789',
    status: 'Cliente',
    lastContact: subDays(new Date(), 3),
    notes: 'Evaluando expansión a nuevas tecnologías'
  },
  {
    id: '5',
    name: 'Luis Martinez',
    position: 'Jefe de Producción',
    email: 'luis.martinez@global.com',
    phone: '+54 341 5678-9012',
    status: 'Prospecto',
    lastContact: subDays(new Date(), 7),
    notes: 'Interesado en optimización de procesos'
  }
];

export const activities = [
  {
    id: '1',
    type: 'meeting',
    title: 'Reunión con TechCorp Centro',
    contactId: '1',
    companyId: null,
    date: new Date(),
    status: 'completed',
    notes: 'Presentación de cotización inicial, muy receptivos'
  },
  {
    id: '2', 
    type: 'contact',
    title: 'Llamada de seguimiento Retail Plus',
    contactId: '2',
    companyId: null,
    date: subDays(new Date(), 1),
    status: 'completed',
    notes: 'Acordamos reunión para próxima semana'
  },
  {
    id: '3',
    type: 'proposal',
    title: 'Cotización integración sistemas',
    contactId: '3',
    companyId: null,
    date: addDays(new Date(), 1),
    status: 'pending',
    amount: 25000,
    notes: 'Cotización técnica completa con cronograma'
  },
  {
    id: '4',
    type: 'meeting',
    title: 'Reunión seguimiento TechCorp Norte',
    contactId: '4',
    companyId: null,
    date: addDays(new Date(), 2),
    status: 'pending',
    notes: 'Revisión de avances del proyecto'
  },
  {
    id: '5',
    type: 'contact',
    title: 'Contacto inicial Global Este',
    contactId: '5',
    companyId: null,
    date: subDays(new Date(), 3),
    status: 'completed',
    notes: 'Primer acercamiento, interés confirmado'
  }
];

export const competitors = [ 
  { 
    id: 'c1', 
    name: 'Maxirest', 
    description: 'Sistema POS y gestión integral para restaurantes, bares y delivery.',
    marketShare: 35,
    strengths: ['Amplia funcionalidad', 'Soporte local', 'Integraciones robustas'],
    weaknesses: ['Costo elevado', 'Interfaz un poco anticuada', 'Curva de aprendizaje']
  },
  { 
    id: 'c2', 
    name: 'Bistrosoft', 
    description: 'Software de gestión para gastronomía con énfasis en la operación de salón y cocina.',
    marketShare: 20,
    strengths: ['Fácil de usar', 'Buena gestión de mesas', 'Precio competitivo'],
    weaknesses: ['Funcionalidades limitadas para grandes cadenas', 'Reportes básicos']
  },
  { 
    id: 'c3', 
    name: 'Aloha POS', 
    description: 'Sistema POS líder global para el sector de hostelería y restauración.',
    marketShare: 15,
    strengths: ['Fiabilidad', 'Escalabilidad', 'Reconocimiento de marca global'],
    weaknesses: ['Alta complejidad de implementación', 'Alto costo mantenimiento', 'No apto para pequeños negocios']
  },
  { 
    id: 'c4', 
    name: 'Micros Oracle', 
    description: 'Suite integral de soluciones de hostelería de Oracle, desde POS hasta gestión hotelera.',
    marketShare: 10,
    strengths: ['Solución empresarial completa', 'Seguridad', 'Estabilidad'],
    weaknesses: ['Extremadamente costoso', 'Requiere infraestructura compleja', 'Soporte técnico centralizado']
  },
  { 
    id: 'c5', 
    name: 'Fudo', 
    description: 'Sistema de gestión gastronómica en la nube, moderno y fácil de usar.',
    marketShare: 8,
    strengths: ['Basado en la nube (accesibilidad)', 'Interfaz moderna e intuitiva', 'Integración con e-commerce'],
    weaknesses: ['Dependencia de la conexión a internet', 'Funcionalidades offline limitadas']
  }
];

export const contactInteractions = [ // Nuevo array para el historial de interacciones
  { 
    id: 'int1', 
    contactId: '1', 
    date: subDays(new Date(), 1), 
    type: 'Llamada', 
    summary: 'Discusión sobre el progreso del proyecto de automatización. Queda pendiente envío de resumen por email.' 
  },
  { 
    id: 'int2', 
    contactId: '1', 
    date: subDays(new Date(), 3), 
    type: 'Email', 
    summary: 'Envío de cotización inicial de solución para TechCorp Centro.' 
  },
  { 
    id: 'int3', 
    contactId: '2', 
    date: subDays(new Date(), 6), 
    type: 'Reunión', 
    summary: 'Presentación de productos a María González. Interesada en la línea de productos ecológicos.' 
  },
  { 
    id: 'int4', 
    contactId: '3', 
    date: subDays(new Date(), 10), 
    type: 'Llamada', 
    summary: 'Contacto inicial con Carlos López para renovación de contrato. Agendada reunión de seguimiento.' 
  }
];

export const weeklyGoals = {
  meetings: { target: 6, current: 4 },
  contacts: { target: 250, current: 180 },
  leads: { target: 5, current: 3 }
};